import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { IoMdCloseCircle } from "react-icons/io";
import { RiEditFill } from "react-icons/ri";

export const FindReview = ({
  register,
  handleSubmit,
  errors,
  onSubmit,
  watch,
  setTabs,
  success,
  setSuccess,
}) => {
  const values = watch();
  console.log(values);
  return (
    <div>
      {success === false ? (
        <div>
          <div className=" rounded-lg py-4">
            {/* Cover Image Section */}
            <div className="w-full h-[100px] sm:h-[280px] rounded-lg overflow-hidden relative group">
              <img
                alt="Cover"
                src="/image/backgroundprofile.png"
                className="w-full h-[100px] sm:h-[280px] object-cover group-hover:opacity-80 transition"
              />
            </div>
          </div>
          <div className=" mx-auto p-0  sm:p-5 space-y-8 text-sm mt-0 ">
            <div className="space-y-5 mt-0 sm:mt-0">
              <div className="flex flex-row justify-between border-b-2">
                <p className="text-lg font-medium">Seller Information</p>
                <button className="text-xs" onClick={() => setTabs(1)}>
                  <RiEditFill className="text-[18px]" />
                </button>
              </div>
              <div>
                <div className="mt-3">
                  <p className="text-gray-500 font-medium text-[14px]">Title</p>
                  <p className="text-lg font-medium">
                    {values.title || "xxxxxxx"}
                  </p>
                </div>

                <div className="mt-3">
                  <p className="text-gray-500 font-medium text-[14px]">
                    Goal Amount
                  </p>
                  <p className="text-lg font-medium">
                    {values.amount || "xxxxxxx"}
                  </p>
                </div>

                <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Start Date{" "}
                    </p>
                    <p className="text-[14px] font-medium">
                      {values.startDate || "xxxxxxx"}
                    </p>
                  </div>
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      End Date
                    </p>
                    <p className="text-[14px] font-medium">
                      {values.endDate || `xxxxxxx`}
                    </p>
                  </div>
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Category
                    </p>
                    <p className="text-[14px] font-medium">
                      {values.category || "xxxxxxx"}{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" mx-auto p-0  sm:p-5 space-y-8 text-sm mt-4  ">
            <div className="space-y-5 ">
              <div className="flex flex-row justify-between border-b-2">
                <p className="text-lg font-medium">Seller Information</p>
                <button className="text-xs" onClick={() => setTabs(2)}>
                  <RiEditFill className="text-[18px]" />
                </button>
              </div>

              <div>
                <div className="mt-3">
                  <p className="text-gray-500 font-medium text-[14px]">
                    Business / Organization Name
                  </p>
                  <p className="text-lg font-medium">
                    {" "}
                    {values.businessName || "xxxxxxx"}{" "}
                  </p>
                </div>

                <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Email
                    </p>
                    <p className="text-[14px] font-medium">
                      {values.email || "xxxxxxx"}
                    </p>
                  </div>
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Mobile Number
                    </p>
                    <p className="text-[14px] font-medium">
                      {values.mobile || "xxxxxxx"}
                    </p>
                  </div>
                </div>

                <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Location
                    </p>
                    <p className="text-[14px] font-medium">
                      {values.address || "xxxxxxx"}{" "}
                    </p>
                  </div>
                </div>
                <div className="mt-4">
                  <label className="text-gray-500 font-medium text-[14px]">
                    Description
                  </label>
                  <div className="mt-1 border rounded-md p-2 min-h-[80px] text-gray-500">
                    {values.description || "Enter Description"}
                  </div>
                </div>
                <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                  <div>
                    <label className="font-semibold">Categories</label>
                    <div className="flex flex-wrap gap-2 mt-2">
                      {["Facebook", "Linkedin", "Instagram"]?.map((tag) => (
                        <a
                          href={`/image/backgroundprofile.png`}
                          className="text-blue-600 underline text-sm"
                        >
                          {tag}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Organization Type
                    </p>
                    <p className="text-[14px] font-medium">{"xxxxxxx"}</p>
                  </div>
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Tax ID / NGO Certification
                    </p>
                    <p className="text-[14px] font-medium">{"xxxxxxx"}</p>
                  </div>
                </div>

                <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Organization Type
                    </p>
                    <p className="text-[14px] font-medium">{"xxxxxxx"}</p>
                  </div>
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Tax ID / NGO Certification
                    </p>
                    <p className="text-[14px] font-medium">{"xxxxxxx"}</p>
                  </div>
                </div>

                <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      License / Registration Certificate
                    </p>
                    <p className="text-[14px] font-medium">{"xxxxxxx"}</p>
                  </div>
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Proof of Address
                    </p>
                    <p className="text-[14px] font-medium">{"xxxxxxx"}</p>
                  </div>
                </div>

                <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Government issued ID
                    </p>
                    <p className="text-[14px] font-medium">{"xxxxxxx"}</p>
                  </div>
                  <div>
                    <p className="text-gray-500 font-medium text-[14px]">
                      Passport Size Photo
                    </p>
                    <p className="text-[14px] font-medium">{"xxxxxxx"}</p>
                  </div>
                </div>
              </div>

              <div>
                <div className="flex flex-row justify-between border-b-2">
                  <p className="text-lg font-medium">Banking Information</p>
                  <button className="text-xs" onClick={() => setTabs(3)}>
                    <RiEditFill className="text-[18px]" />
                  </button>
                </div>
                <div>
                  <div className="mt-3">
                    <p className="text-gray-500 font-medium text-[14px]">
                      Country
                    </p>
                    <p className="text-lg font-medium">{"xxxxxxx"}</p>
                  </div>

                  <div className="mt-3">
                    <p className="text-gray-500 font-medium text-[14px]">
                      Beneficiary Name
                    </p>
                    <p className="text-lg font-medium">{"xxxxxxx"}</p>
                  </div>

                  <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                    <div>
                      <p className="text-gray-500 font-medium text-[14px]">
                        Bank Name
                      </p>
                      <p className="text-[14px] font-medium">{"xxxxxxx"}</p>
                    </div>
                    <div>
                      <p className="text-gray-500 font-medium text-[14px]">
                        Account Number
                      </p>
                      <p className="text-[14px] font-medium">{"xxxxxxx"}</p>
                    </div>

                    <div>
                      <p className="text-gray-500 font-medium text-[14px]">
                        IFSC or SWIFT Code
                      </p>
                      <p className="text-[14px] font-medium">{"xxxxxxx"}</p>
                    </div>
                  </div>

                  <div className="mt-3 flex sm:flex-row flex-col gap-4 sm:gap-20">
                    <div>
                      <p className="text-gray-500 font-medium text-[14px]">
                        Passbook / Cancelled cheque
                      </p>
                      <div className="flex items-center gap-2 mt-1">
                        <a
                          href={`/image/backgroundprofile.png`}
                          className="text-blue-600 underline text-sm"
                        >
                          {"xxxxxxx"}
                        </a>
                        <button className="text-red-500 text-lg">
                          <IoMdCloseCircle />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-between mt-6">
              <button
                onClick={() => setTabs(1)}
                type="button"
                className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
              >
                <FaAngleLeft /> Back
              </button>

              {/* ✅ Next should SUBMIT instead of just switching tab */}
              <button
                type="submit"
                className="px-6 py-2 rounded-full flex items-center gap-10 bg-[#74131C] text-white hover:bg-green-900"
              >
                Submit <FaAngleRight />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="p-4 mt-10 flex flex-col justify-center w-full">
          <div className="w-full h-[300px]">
            <img
              src="/image/fundsuccess.png"
              alt="img"
              className="mx-auto h-full"
            />
          </div>
          <p className="mt-10 text-green-600 text-center font-semibold">
            Fund Created Successfully
          </p>
        </div>
      )}
    </div>
  );
};
